import React from 'react';
import FuelPriceCard from './FuelPriceCard';

function App() {
  return <FuelPriceCard />;
}

export default App;
